/* @flow */
import React from 'react';
import {observer} from 'mobx-react';
import {cssTransition, ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import './alert.scss';
import {TOAST_AUTO_CLOSE_TIME} from "../../constants/constants";
import {xmlBg} from '../../themes/colors';

type Props = {
    className: ?string,
    style: ?Object,
    alertClassName: ?string,
    bodyClassName: ?string,
    withProgress: ?boolean
};

const containerStyle = {minWidth: 364, maxWidth: 434, backGroundColor: xmlBg};

const noAnimation = cssTransition({
    enter: 'alert-enter',
    exit: 'alert-leave'
});


const AlertContainer = ({className, style: propStyle, alertClassName, bodyClassName, withProgress}: Props) => (
    <ToastContainer
        style={{...containerStyle, ...propStyle}}
        hideProgressBar={!withProgress} pauseOnHover={false}
        transition={noAnimation}
        autoClose={TOAST_AUTO_CLOSE_TIME}
        closeButton={false}
        className={`alert-container ${className || ''}`}
        toastClassName={`alert ${alertClassName || ''}`}
        bodyClassName={`alert-body ${bodyClassName || ''}`}
    />
);

export default observer(AlertContainer);
